import { cn } from '../lib/cn';

export interface TimerRingProps {
  /** Скільки секунд лишилось. */
  remaining: number;
  total: number;
  size?: number;
  className?: string;
  label?: string;
}

/**
 * Кільцевий таймер. Свідомо без анімації по кадрах — оновлюється
 * раз на секунду разом зі станом, тож не гріє батарею телефона.
 */
export function TimerRing({
  remaining,
  total,
  size = 64,
  className,
  label,
}: TimerRingProps): React.JSX.Element {
  const safeTotal = Math.max(1, total);
  const ratio = Math.max(0, Math.min(1, remaining / safeTotal));
  const stroke = Math.round(size * 0.11);
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = circumference * ratio;

  const color =
    ratio > 0.5 ? 'var(--lk-green)' : ratio > 0.22 ? 'var(--lk-gold)' : 'var(--lk-red)';

  return (
    <div
      className={cn('relative grid place-items-center', className)}
      style={{ width: size, height: size }}
      role="timer"
      aria-live="off"
      aria-label={label ?? `Лишилось ${Math.ceil(remaining)} секунд`}
    >
      <svg width={size} height={size} className="-rotate-90" aria-hidden>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="rgba(0,0,0,.45)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circumference}`}
          style={{ transition: 'stroke-dasharray 400ms linear, stroke 400ms ease' }}
        />
      </svg>
      <span
        className="tabular absolute font-black"
        style={{ fontSize: size * 0.32, color }}
      >
        {Math.max(0, Math.ceil(remaining))}
      </span>
    </div>
  );
}
